import map from 'lodash/map'
import pickBy from 'lodash/pickBy'

import { CustomFieldsAttributes, CustomFieldsGroup } from '@lk/api'

export const customFieldsAttributesToString = (
  attributes: CustomFieldsAttributes & {
    groupId: CustomFieldsGroup
  },
) => {
  const attributesWithValues = pickBy(attributes)
  return map(attributesWithValues, (value, key) => `${key}/${value}`).join('&')
}
